import classNames from 'classnames';
import BEM from 'common/bem';

const classes = BEM.with('StatusBar');

export const STATUS_BAR_DISMISS_LABEL = 'Dismiss';

type StatusBarProps = {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'error' | 'neutral';
  className?: string;
  action?: React.ReactNode;
  onDismiss?: () => void;
  'data-test-id'?: string;
  'data-variant'?: string;
};

function StatusBar({
  children,
  variant = 'neutral',
  className,
  action,
  onDismiss,
  'data-test-id': dataTestId,
  'data-variant': dataVariant,
}: StatusBarProps) {
  return (
    <div
      className={classNames(className, classes({ variant }))}
      role="status"
      data-test-id={dataTestId}
      data-variant={dataVariant}
    >
      {children}
      {action ? <span className={classes('action')}>{action}</span> : null}
      {onDismiss ? (
        <button
          type="button"
          className={classes('dismiss')}
          aria-label={STATUS_BAR_DISMISS_LABEL}
          onClick={onDismiss}
        >
          &times;
        </button>
      ) : null}
    </div>
  );
}

export default StatusBar;
